import is from "is_js"; // quiet
import { PermissionStatuses } from "./PermissionStatuses.js";

//==============================================================================
/**
 * environmental settings
 */
let Environment = 
  {
    isIFramed        : window.self !== window.parent,
    isIOS13          : is.ios(">=13"),
    hasGyro          : is.not.desktop() && !!window.DeviceOrientationEvent,
    hasPermissions   : ( !!window.DeviceOrientationEvent && typeof window.DeviceOrientationEvent.requestPermission === "function" ),
    permissionStatus : PermissionStatuses.UNKNOWN
  };
export { Environment };